import { primaryColor, dangerColor, whiteColor } from 'assets/jss/material-dashboard-pro-react';

const tagStyle = () => ({
	tag: ({ marginLeft, marginRight }) => ({
		borderWidth: 2,
		borderStyle: 'solid',
		borderRadius: 8,
		padding: 4,
		marginLeft: marginLeft,
		marginRight: marginRight,
	}),
	primaryTag: {
		borderColor: primaryColor[0],
		'& p': {
			color: primaryColor[0],
		},
	},
	dangerTag: {
		borderColor: dangerColor[0],
		'& p': {
			color: dangerColor[0],
		},
	},
	whiteTag: {
		borderColor: whiteColor,
		'& p': {
			color: whiteColor,
		}
	},
});

export default tagStyle;
